export const studentSeminarLabsConstants = {
    REQUEST: 'STUDENT_SEMINAR_LABS_REQUEST',
    GET_ALL_LABS_SUCCESS: 'STUDENT_SEMINAR_LABS_GET_ALL_LABS_SUCCESS',
    GET_ALL_LABS_ERROR: 'STUDENT_SEMINAR_LABS_GET_ALL_LABS_ERROR',
    HANDLE_CLICK_LAB: 'HANDLE_CLICK_LAB',
    HANDLE_SELECT_ALL_CLICK_LAB: 'HANDLE_SELECT_ALL_CLICK_LAB',
    CHANGE_PAGE: 'CHANGE_PAGE',
    CHANGE_PAGE_SIZE: 'CHANGE_PAGE_SIZE'
};
